module.exports = __webpack_public_path__ + "60d538c4cbc036f46dea4457b6077956.svg";